import { Typography } from '@startuptools/ui/Typography';
import { MeetingKindHuman } from '../../meetings/components/MeetingKindHuman';
import { GqlMeeting, GqlMeetingHeldKind, GqlMeetingKind } from '../../../graphql/base-types.graphql';
import { DateFormat } from '@startuptools/ui/DateFormat';
import { MeetingHeldKindHuman } from '../../meetings/components/MeetingHeldKindHuman';
import { useLingui } from '@lingui/react';
import { DateTime } from 'luxon';

export const Meeting = ({ meeting }: { meeting: Pick<GqlMeeting, 'kind' | 'number' | 'heldKind' | 'startTime'> }) => {
  const { i18n } = useLingui();

  return (
    <>
      <Typography level="title-lg">
        <MeetingKindHuman>{meeting.kind}</MeetingKindHuman>
        {meeting.kind === GqlMeetingKind.BoardMeeting && ` #${meeting.number}`}
      </Typography>
      <Typography level="body-sm" component="span">
        <DateFormat
          locale={i18n.locale}
          format={meeting.heldKind === GqlMeetingHeldKind.PerCapsulam ? undefined : DateTime.DATETIME_SHORT}
        >
          {meeting.startTime}
        </DateFormat>
        {' - '}
        <MeetingHeldKindHuman>{meeting.heldKind}</MeetingHeldKindHuman>
      </Typography>
    </>
  );
};
